import { useQuery } from '@tanstack/react-query'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery, useApi } from '@fortem-monorepo/react-spa'
import { MonthlyRoll } from '@fortem-monorepo/web-sdk'

import { getMonthlyRollOptions } from '@/react-query/queries/monthly-roll'

const colDefs = createColDefs([
  { field: 'fund_name', headerName: 'Fund' },
  // { field: "shareclass_id" },
  { field: 'shareclass_code', headerName: 'Shareclass Code' },
  { field: 'shareclass_sleeve', headerName: '#Sleeve' },
  { field: 'agent_ref_number', headerName: 'Deal Ref' },
  { field: 'trade_datetime_utc', headerName: 'Trade Date' },
  { field: 'settlement_date', headerName: 'Settlement Date' },
  { field: 'open_date', headerName: 'Open Date' },
  { field: 'trade_currency', headerName: 'Trade CCY' },
  {
    field: 'Forwards Additional',
    headerName: 'Trade QTY',
    valueFormatter: numberFormatter({ delimiter: true }),
  },
  { field: 'fund_currency', headerName: 'Fund CCY' },
  { field: 'price', valueFormatter: numberFormatter({ maximumFractionDigits: 4 }) },
])

export interface MonthlyRollAdditionalTradesTableProps {
  params: MonthlyRoll.GetMonthlyRollParams
}

export const MonthlyRollAdditionalTradesTable: React.FC<MonthlyRollAdditionalTradesTableProps> = ({
  params,
}) => {
  const api = useApi()
  const query = useQuery({
    ...getMonthlyRollOptions(api, params),
    enabled: false,
  })

  return (
    <Widget exposed className={'h-full'}>
      <WidgetHeaderWithQuery query={query} title="Additional Trades" />
      <WidgetContent loading={query?.isLoading}>
        <CustomAgGrid
          columnDefs={colDefs}
          rowData={query.data?.additional_trades}
          autoSizeStrategy={{ type: 'fitCellContents' }}
          domLayout={'normal'}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}
